import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const entity = 'company'
const entityMsg = 'company'

let customActions = {}

const createAddFile = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/company/create_add_file`, {
			method: 'PATCH',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				files: files,
				item: JSON.stringify(item),
			},
		})
		if (res.status == 200) {
			showSuccessMessage(`Se subió el comprobante correctamente.`)
		} else {
			showErrorMessage(`Error al subir el comprobante.`)
		}
		return dispatch({
			type: `UPLOAD_${entity.toUpperCase()}_TICKET`,
			response: res,
			payload: res.id,
		})
	}
}

const updateAddFile = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/company/${item.id}/update_add_file`, {
			method: 'PATCH',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				files: files,
				item: JSON.stringify(item),
			},
		})

		dispatch(actions.get(item.id))
		if (res.status == 200) {
			showSuccessMessage(`Se guardó correctamente la información.`)
		} else {
			showErrorMessage(`Error al guardar información.`)
		}
		return dispatch({
			type: `UPLOAD_${entity.toUpperCase()}_TICKET`,
			response: res,
			payload: item.id,
		})
	}
}

const loadCompanies = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/company/get_companies_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `GET_ALL_COMPANIES_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const getCompany = (id, params) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/company/utils/get_company/${id}`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: params?.params
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getCustomCompanies = (params) => {
	return async (dispatch, getState) => {
		const state = getState()


		const res = await callApi(`/company/custom_companies`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params,
		})

		return res.body
	}
}

customActions = { ...customActions, createAddFile }
customActions = { ...customActions, updateAddFile, getCompany, getCustomCompanies }

const actions = {
	...crud('company', 'la empresa', 'las empresas'),
	...customActions,
	loadCompanies,
}

export default actions
